import { api } from "@";
import { searchValuesPayload } from "./helpers";

// Fetch donations with pagination and search filters
export const getDonations = (page = 1, perSize = "", search) =>
  api.post(
    `/api/AdminOrder/orders`,
    searchValuesPayload({ ...search, page, perSize }),
  );

// Fetch donation items
export const getOrderLines = (orderId) =>
  api.get(`/api/AdminOrder/order-lines/${orderId}`);

// Search order activity events (paginated)
export const searchOrderEvents = ({ orderId, page = 1, pageSize = 10 }) =>
  api.post(`/api/OrderEvents/search`, { orderId, page, pageSize });

// Save donation items
export const saveOrderLines = (data, orderId) => {
  const payload = {
    orderLines: data.map((item) => ({
      id: item.id,
      quantity: item.quantity,
      unitPrice: item.unitAmount,
    })),
  };

  return api.patch(`/api/AdminOrder/order-lines-amount/${orderId}`, payload);
};

// Save notes for a specific order
export const saveNote = (data) =>
  api.post(`/api/AdminOrder/orders/${data?.id}/notes`, {
    orderNote: data.notes,
  });

// Set an order as paid
export const setAsPaid = (id) =>
  api.put(`/api/AdminOrder/orders/${id}/status?isPaid=true`);

// Reject a bank transfer for a specific order
export const saveRejectBankTransfer = (id) =>
  api.put(`/api/AdminOrder/orders/${id}/reject`);

// export all donations data
export const exportAllCharityOrderingData = () => {
  return api.post(
    `/api/AdminOrder/export-all-charity-ordering-data?fromDate=&toDate=`,
    {},
    {
      responseType: "blob",
    },
  );
};